import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, Typography, useViewport } from '@chilecompra/react-kit'
import { handleKeyDown, useAccessibility } from '../../../modules/utils/accesibility'
import {
  DialogButtonContainer,
  DialogContainer,
  DialogSubContainer,
  InstitutionsList,
  InstitutionsListContainer,
  InstitutionsListItem
} from './RegisterWizardWelcome.styles'

/**
 * The Mandatory Institutions's modal component.
 */
const MandatoryInstitutionsModal = ({ open, onClose, confirmAction }) => {
  const { size } = useViewport()
  const modalRef = useRef(null)

  useAccessibility(open, size, modalRef)

  const onHandleKeyDown = event => () => handleKeyDown(event, onClose)

  return (
    <>
      <Dialog
        onClose={onClose}
        open={open}
        maxWidth="712px"
        margin="84px 18px 84px 18px"
        padding="0"
        verticalAlign="center"
        aria-labelledby="mandatory-institutions-modal-title"
        aria-describedby="mandatory-institutions-modal-description"
        ref={modalRef}
      >
        <DialogContainer>
          <DialogSubContainer>
            <Typography
              tabIndex="0"
              id="mandatory-institutions-modal-title"
              fontWeight="bold"
              variant="h4"
              textAlign="left"
            >
              Instituciones obligadas a registrarse en Mercado Público
            </Typography>
            <Typography
              tabIndex="0"
              id="mandatory-institutions-modal-description"
              margin="20px 0 0"
              variant="body2"
              textAlign="left"
            >
              A continuación podrás revisar el listado de instituciones comprendidas en el artículo 1 y el artículo 3
              bis de la ley N° 19.886 de compras públicas.
            </Typography>

            <InstitutionsListContainer>
              <InstitutionsList>
                <InstitutionsListItem tabIndex="0">
                  Organismo de la Administración del Estado(art.1 iniciso 2° LOCBGAE)
                </InstitutionsListItem>
                <InstitutionsListItem tabIndex="0">Corporaciones Municipales</InstitutionsListItem>
                <InstitutionsListItem tabIndex="0">Fundaciones de la Presidencia</InstitutionsListItem>
                <InstitutionsListItem tabIndex="0">
                  Corporaciones con participación de la Administración del Estado, que reciban asignaciones públicas
                  sobre 1.500 UTM, identificadas por D.S
                </InstitutionsListItem>
                <InstitutionsListItem tabIndex="0">Congreso Nacional</InstitutionsListItem>
                <InstitutionsListItem tabIndex="0">Poder Judicial</InstitutionsListItem>
                <InstitutionsListItem tabIndex="0">CGR</InstitutionsListItem>
                <InstitutionsListItem tabIndex="0">Ministero Público</InstitutionsListItem>
                <InstitutionsListItem tabIndex="0">
                  TC, TDLC, TRICEL, Tribunales Electorales Regionales, Tribunales Ambientales
                </InstitutionsListItem>
                <InstitutionsListItem tabIndex="0">SERVEL</InstitutionsListItem>
                <InstitutionsListItem tabIndex="0">CNTV</InstitutionsListItem>
              </InstitutionsList>
            </InstitutionsListContainer>
          </DialogSubContainer>
          <DialogButtonContainer>
            <Button
              tabIndex="0"
              aria-label="Cerrar"
              color="default"
              onClick={confirmAction}
              onKeyDown={onHandleKeyDown}
            >
              Cerrar
            </Button>
          </DialogButtonContainer>
        </DialogContainer>
      </Dialog>
    </>
  )
}

MandatoryInstitutionsModal.defaultProps = {
  confirmAction: () => undefined,
  onClose: () => undefined,
  open: false
}

MandatoryInstitutionsModal.propTypes = {
  confirmAction: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool
}

export default MandatoryInstitutionsModal
